import React from 'react'
import {Container, Col, Row, Button} from 'reactstrap'

const Menu = (props) => {
    console.log(props)
    return (
        <>
            <div style={{backgroundImage: `url(https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/background_300.png)`}} className="background left">
                <div className="menu-header">
                            <img 
                                className="logo" 
                                src={`https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/pink_square_logo.png`}
                            />
                            <img 
                                className="taps-header" 
                                src={props.menuImage}
                            />
                </div>
                <div className="bottles-cans-section">
                    {props.menuName == 'bottles-cans'
                        ?   props.menuData.sections
                                ?   props.menuData.sections.map(section => (
                                        <div className="section">
                                            <span className="header-title">{section.name}</span>
                                            <div>
                                                {section.items.map(item => (
                                                    <div className="beer-title">
                                                        <span>{item.name}</span>
                                                        <span> ({
                                                            
                                                            item.original_brewery.replace("Company", '').replace("Cooperative", '').replace("Brewing", '').replace("Brewery", '')
                                                        })</span>
                                                        <span> {item.style.split('-',1)}</span> | 
                                                        <span> {item.abv}% </span>
                                                        <span>{item.containers[0].container_size.name.split(' ',1)}</span>
                                                    </div>
                                                ))

                                                }
                                            </div>
                                            <span></span>
                                        </div>
                                    ))
                                :   <span></span>
                        :   <span></span>
                    }
                </div>
                <div className="wine-container">
                    {props.menuName == 'red-wine' || props.menuName == 'white-wine'
                        ?   props.menuData.custom_items
                                ?   props.menuData.custom_items.map(item => (
                                    <div className="wine-items">
                                        <div className="wine-item">
                                            <div className="item-title">
                                                {item.name}
                                            </div>
                                            <div className="item-description">{item.description}</div>
                                            <div className="item-price">{
                                                item.custom_containers.map(container => (
                                                <>
                                                    <span className="item-price">{container.name} - </span> 
                                                    <span className="item-price"> {container.price} </span>
                                                </>
                                                ))
                                            }</div>
                                        </div>
                                        
                                    </div>    
                                    ))
                                :   <span></span>
                        :   <span></span>
                    }
                </div>
               
            </div>
            <div style={{backgroundImage: `url(https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/background_300.png)`}} className="background right">
                <div className="menu-header">
                                <img 
                                    className="logo" 
                                    src={`https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/pink_square_logo.png`}
                                />
                                <img 
                                    className="taps-header" 
                                    src={props.menuImage}
                                />
                </div>
                <div className="bottles-cans-section">
                    {props.menuName == 'bottles-cans'
                        ?   props.menuData.sections
                                ?   props.menuData.sections.map(section => (
                                        <div className="section">
                                            <span className="header-title">{section.name}</span>
                                            <div>
                                                {section.items.map(item => (
                                                    <div className="beer-title">
                                                        <span>{item.name}</span>
                                                        <span> ({
                                                            
                                                            item.original_brewery.replace("Company", '').replace("Cooperative", '').replace("Brewing", '').replace("Brewery", '')
                                                        })</span>
                                                        <span> {item.style.split('-',1)}</span> | 
                                                        <span> {item.abv}% </span>
                                                        <span>{item.containers[0].container_size.name.split(' ',1)}</span>
                                                    </div>
                                                ))

                                                }
                                            </div>
                                            <span></span>
                                        </div>
                                    ))
                                :   <span></span>
                        :   <span></span>
                    }
                </div>
                <div className="wine-container">
                    {props.menuName == 'red-wine' || props.menuName == 'white-wine'
                        ?   props.menuData.custom_items
                                ?   props.menuData.custom_items.map(item => (
                                    <div className="wine-items">
                                        <div className="wine-item">
                                            <div className="item-title">
                                                {item.name}
                                            </div>
                                            <div className="item-description">{item.description}</div>
                                            <div className="item-price">{
                                                item.custom_containers.map(container => (
                                                <>
                                                    <span className="item-price">{container.name} - </span> 
                                                    <span className="item-price"> {container.price} </span>
                                                </>
                                                ))
                                            }</div>
                                        </div>
                                        
                                    </div>    
                                    ))
                                :   <span></span>
                        :   <span></span>
                    }
                </div>
                    

            </div>
            
            
            
        </>
    )
}
export default Menu